export const APP_DEBUG=false;
export const APP_API_URL = process.env.NODE_ENV=="development"?"http://192.168.0.153/laparapi/public/api/":"http://lapar.gonow.my/api/";
export const APP_FILE_URL = process.env.NODE_ENV=="development"?"http://192.168.0.153/laparapi/public/":"http://lapar.gonow.my/";
export const APP_STORAGE_URL = process.env.NODE_ENV=="development"?"http://192.168.0.153/laparapi/public/storage/":"http://lapar.gonow.my/storage/";
// export const APP_API_URL = "http://lapar.gonow.my/api/";
// export const APP_FILE_URL = "http://lapar.gonow.my/";
// export const APP_STORAGE_URL = "http://lapar.gonow.my/storage/";
export const APP_VERSION=2;
export const APP_VERSION_NAME="v1.0.2";